import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0C4.029 0 0 4.029 0 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm-.224 8.141l.891.286v-.001c.988.307 2.826.877 2.826 2.902 0 1.532-1.074 2.625-2.744 2.899V16h-1.5v-1.746c-1.685-.207-2.721-1.213-2.744-2.736l1.5-.021c.012.863.653 1.302 1.904 1.302.489 0 2.083-.106 2.083-1.47 0-.714-.397-1.043-1.77-1.469l-.005-.003-.891-.286c-.982-.303-2.82-.874-2.82-2.899 0-1.532 1.074-2.625 2.744-2.899V2h1.5v1.746c1.685.207 2.721 1.213 2.744 2.736l-1.5.021c-.012-.863-.653-1.302-1.904-1.302-.489 0-2.083.106-2.083 1.47-.001.715.396 1.044 1.769 1.47z" />
  </svg>
);

export default SvgComponent;
